import React from 'react'
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { useDndContext, useDroppable } from "@dnd-kit/core";
import SortableItem from './SortableItem';

const DroppableColumn = ({ colKey, column, selectMode, selectedCardIds, setSelectedCardIds, onColumnClick, activeId }) => {
    const { setNodeRef } = useDroppable({
        id: colKey,
    });
    const { over } = useDndContext()
    const itemIdsInColumn = column.items.map(item => item.id);
    const isActiveDropTarget = over?.id === colKey || itemIdsInColumn.includes(over?.id);


    return (
        <div
            ref={setNodeRef}
            style={{
                background: isActiveDropTarget ? "#e0e0e0" : "#f4f5f7",
                borderRadius: 8,
                minWidth: 250,
                width:"30%",    
                flex: 1,
                padding:"5px",
                transition: "background 0.2s, box-shadow 0.2s, border 0.2s",
                cursor: selectMode ? "pointer" : "default",
                border: isActiveDropTarget ? "2px solid #1976d2" : "2px solid transparent",
                boxShadow: isActiveDropTarget ? "0 0 8px #1976d2" : "none",
            }}
            onClick={selectMode ? () => onColumnClick(colKey) : undefined}
        >
            <div className='status-name'>
                <div className='text-center'>{column.name}</div>
                <div className='text-center task-count'><p>{column?.items?.length}</p></div>
                {/* <span className='min'>MIN: 1</span>
                <span className='max'>MAX: 3</span> */}
            </div>
            <div>
                <SortableContext
                    id={colKey}
                    items={column.items.map((item) => item.id)}
                    strategy={verticalListSortingStrategy}
                >
                    {column.items.length === 0 && (
                        <div className='drop-card'>
                            Drop here
                        </div>
                    )}
                    {column.items.map((item) => (
                        <SortableItem
                            key={item.id}
                            id={item.id}
                            selectMode={selectMode}
                            selectedCardIds={selectedCardIds}
                            setSelectedCardIds={setSelectedCardIds}
                        >
                            {item}
                        </SortableItem>
                    ))}
                </SortableContext>
            </div>
        </div>
    );
}

export default DroppableColumn;
